import { main_url } from "../pages/basefile";
import { getValidToken } from "../auth/getToken";

/**
 * Fetches server-tracked previous login time (shared across browsers).
 * @returns {Promise<string|null>} ISO timestamp or null
 */
export async function reportAuthAuditEvent(eventType) {
  const token = (await getValidToken()) || localStorage.getItem("authToken");
  if (!token) {
    return;
  }
  await fetch(`${main_url}/api/v1/auth/audit-events`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ event_type: eventType }),
  });
}

export async function fetchPreviousLoginAt() {
  const token = (await getValidToken()) || localStorage.getItem("authToken");
  if (!token) {
    return null;
  }
  const res = await fetch(`${main_url}/api/v1/auth/last-login`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    return null;
  }
  const data = await res.json();
  return data.previous_login_at || null;
}
